import React from "react"

export const ArrowPrevIcon = () => {
  return (
    <svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.14478 18C7.94752 18 7.75026 17.9273 7.59452 17.7716L0.825379 11.0025C-0.275126 9.90195 -0.275126 8.09546 0.825379 6.99496L7.59452 0.225811C7.89561 -0.0752704 8.39395 -0.0752704 8.69503 0.225811C8.99611 0.526893 8.99611 1.02523 8.69503 1.32632L1.92588 8.09546C1.42754 8.5938 1.42754 9.40361 1.92588 9.90195L8.69503 16.6711C8.99611 16.9722 8.99611 17.4705 8.69503 17.7716C8.5393 17.9169 8.34204 18 8.14478 18Z" fill="#292D32"/>
    </svg>
  )
}
